import { nettoyerHtml } from '../../utils/nettoyerHtml';
import { useEffect, useState } from 'react';
import axios from 'axios';

// Texte officiel de la charte (servi par le backend, identique au PDF de la lettre de mission)
export const CharteTexte = () => {
  const [sections, setSections] = useState([]);
  useEffect(() => {
    axios.get('/charte-formateurs/texte').then(({ data }) => setSections(data)).catch(() => setSections([]));
  }, []);
  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-10 shadow-sm" data-testid="ma-charte-texte">
      <div className="space-y-7">
        {sections.map((s, i) => (
          <section key={s.titre} className="animate-in fade-in slide-in-from-bottom-2 duration-500 fill-mode-both" style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`ma-charte-section-${i}`}>
            <h2 className="text-base md:text-lg font-semibold text-[#1E40AF]">{s.titre}</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed text-slate-700" dangerouslySetInnerHTML={{ __html: nettoyerHtml(s.contenu) }} />
          </section>
        ))}
      </div>
    </article>
  );
};
